import { memo as Memo } from 'react'

//* Components
import Image from 'components/common/Image'
import { ReactCompareSlider } from 'react-compare-slider'

//* Style
import SwipeSectionStyle from './style'

const SwipeSection = Memo(({ className, first_image, second_image }) => {
	return (
		<SwipeSectionStyle className={`${className || ''}`}>
			<ReactCompareSlider
				boundsPadding={5}
				changePositionOnHover
				itemOne={<Image priority src={first_image.url} alt={first_image.alt} />}
				itemTwo={<Image priority src={second_image.url} alt={second_image.alt} />}
				handle={<div className={`handle`} />}
				position={50}
			/>
		</SwipeSectionStyle>
	)
})

export default SwipeSection
